import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LScreen from "@components/LScreen";
import LText from "@components/LText";

export const EmptyAccessScreen = () => {
  return (
    <LScreen alignItems="center" enableAutomaticTopPadding={true}>
      <LBox gap="s2" maxWidth={300} alignItems="center" marginTop="xl1">
        <LIcon name="star_grey_circle" size={44} />
        <LText variant="messageTitle">No experiences yet</LText>
        <LText variant="messageBody">
          It seems a bit quiet here at the moment. When new experiences are
          added, you&apos;ll find them right here.
        </LText>
      </LBox>
    </LScreen>
  );
};
